import React, { useEffect, useRef } from 'react';
import Chart from 'chart.js/auto';

interface Flight {
    'company name': string;
    price: number;
}

interface AirlineTotals {
    [key: string]: number;
}

const processFlightData = (data: {flightsData:Flight[]}): AirlineTotals => {
    const {flightsData} = data;
    const airlineTotals: AirlineTotals = {};
    const elAl = "El Al Israel";

    flightsData.forEach(flight => {
        const airline = flight['company name'];
        if (airline !== elAl) {
            if (!airlineTotals[airline]) {
                airlineTotals[airline] = 0;
            }
            airlineTotals[airline] += flight.price;
        }
    });

    return airlineTotals;
};
// @ts-ignore
const DestPriceByAirline = ({ data }) => {
    const canvasRef = useRef(null);
    const chartInstanceRef = useRef(null);

    useEffect(() => {
        if (chartInstanceRef.current) {
            // @ts-ignore
            chartInstanceRef.current.destroy();
        }

        const airlineTotals = processFlightData(data);
        const labels = Object.keys(airlineTotals);
        const dataset = Object.values(airlineTotals);
        const backgroundColors = [
            "rgba(255,158,12,0.61)",
            "rgba(1,62,128,0.6)",
            "rgb(255,61,61)",
            "rgba(136,80,0,0.61)",
            "rgba(250,207,99,0.2)"
        ]
        const borderColors = [
            "rgba(255,158,12,0.61)",
            "rgba(1,62,128,0.6)",
            "rgb(255,61,61)",
            "rgba(136,80,0,0.61)",
            "rgba(250,207,99,0.2)"
        ]

        // @ts-ignore
        const ctx = canvasRef.current.getContext('2d');
        // @ts-ignore
        chartInstanceRef.current = new Chart(ctx, {
            type: 'pie',
            data: {
                labels: labels,
                datasets: [{
                    data: dataset,
                    backgroundColor: backgroundColors,
                    borderColor: borderColors,
                    borderWidth: 1
                }]
            },
            options: {
                plugins: {
                    title: {
                        display: true,
                        text: 'Price Distribution by Airline',
                        font: {
                            size: 20
                        },
                        padding: {
                            top: 20,
                            bottom: 30
                        }
                    },
                    legend: {
                        display: true,
                        position: 'bottom',
                        labels: {
                            font: {
                                size: 14
                            },
                            usePointStyle: true,
                            padding: 20
                        }
                    },
                    tooltip: {
                        callbacks: {
                            label: function(context) {
                                const label = context.label || '';
                                const value = context.raw || 0;
                                const total = context.dataset.data.reduce((sum, val) => sum + val, 0);
                                // @ts-ignore
                                const percentage = ((value / total) * 100).toFixed(2);
                                return `${label}: $${value.toLocaleString()} (${percentage}%)`;
                            }
                        }
                    }
                }
            }
        });

        return () => {
            if (chartInstanceRef.current) {
                // @ts-ignore
                chartInstanceRef.current.destroy();
            }
        };
    }, [data]);

    const getRandomColor = () => {
        const letters = '0123456789ABCDEF';
        let color = '#';
        for (let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return `rgba(${parseInt(color.slice(1, 3), 16)}, ${parseInt(color.slice(3, 5), 16)}, ${parseInt(color.slice(5, 7), 16)}, 0.2)`;
    };

    return (
        <div>
            <canvas ref={canvasRef} width="800" height="400"></canvas>
        </div>
    );
};

export default DestPriceByAirline;
